<script setup lang="ts">
import { BrComponent, BrPage } from '@bloomreach/vue-sdk'

const { mapping, configuration, page } = await useBrxm()
const isPreview = page?.preview
</script>

<template>
    <BrPage
        :configuration="configuration"
        :mapping="mapping"
        :page="page"
    >
        <template #default="{ page, component }">
            <template v-if="page">
                <template v-if="isPreview">
                    <BrComponent :component="component" />
                </template>

                <template v-else>
                    <BrComponent component="body/common/Header" />
                    <BrComponent component="body/common/main" />
                    <BrComponent component="body/common/Footer" />
                </template>
            </template>
        </template>
    </BrPage>
</template>
